export const formatAsCurrency = (
  value: string | number | null,
  decimalplaces?: number,
) => {
  if (!value) return "";

  const num = Number(value);
  if (Number.isInteger(num) || decimalplaces === 0) {
    const truncated = Math.floor(num);
    return truncated.toLocaleString("en-GB", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }
  if (decimalplaces && decimalplaces > 0) {
    return num.toLocaleString("en-GB", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: decimalplaces,
      maximumFractionDigits: decimalplaces,
    });
  }
  return num.toLocaleString("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const calculateMonthToYear = (months?: number) => {
  if (!months) return null;
  const years = months / 12;
  return years.toString();
};
